import { IPeriodConfiguration, AggregationConfiguration, TimeInterval, NameBuilderConfiguration } from '../../';
import { ScatterPlotSeriesConfiguration } from './scatterPlotSeriesConfiguration';
import { ChartConfigurationOption } from '../../../wtFramework';
import { PeriodReference } from '../../../models';

export class ScatterPlotConfiguration implements IPeriodConfiguration {
    series: ScatterPlotSeriesConfiguration[];
    options: ChartConfigurationOption;
    aggregation: AggregationConfiguration;
    minPeriod: TimeInterval;
    maxPeriod: TimeInterval;
    alignedOn:PeriodReference;
    isEndDateIncluded = false;
    nameConfiguration: NameBuilderConfiguration;
    shapes: any[];

    constructor() {
        this.series = [];
        this.options = new ChartConfigurationOption();
        this.aggregation = new AggregationConfiguration();
        this.nameConfiguration = new NameBuilderConfiguration();
        this.nameConfiguration.hasUnit = true;
        this.alignedOn = PeriodReference.End;
    }
}